import React, {useState, useEffect} from 'react';
import '../../css/App.css'
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap';

/************************************************************************
This component is responsable for getting screenshots made during a shift
*************************************************************************/

class PayrollScreenShots extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screenshotList: [],
      selectedScreenshot:"",
      showZoomScreenshot:false
    }
    this.callScreenshots = this.callScreenshots.bind(this)
    this.zoomScreenshot = this.zoomScreenshot.bind(this)
    this.zoomOutScreenshot = this.zoomOutScreenshot.bind(this)
  }

  //Just put the correct time on the snoozer
  componentDidMount(){
    this.callScreenshots();
  }

  callScreenshots = async () => {
    let fetchRequest = await fetch("https://dashboard.realsexdoll.info/php/payroll/userscreenshots.php?shiftId="+this.props.id);
    const result = await fetchRequest.json();
    console.log(result);
    this.setState({screenshotList:result});
  }

  zoomScreenshot = (i) =>{
    const screenshotFolder = "https://dashboard.realsexdoll.info/screenshots/";
    const screenshotSelected = this.state.screenshotList[i].imgPath;
    const screenshotLink = screenshotFolder+screenshotSelected;
    this.setState({selectedScreenshot:screenshotLink})
    this.setState({zoomScreenshot:true});
  }

  zoomOutScreenshot = () =>{
    this.setState({zoomScreenshot:false});
  }

  render() {

    let windowZoomScreenshot;
    if(this.state.showZoomScreenshot){
      windowZoomScreenshot = 
      <div>
        <div className='pop-up' onClick={this.zoomOutScreenshot}></div>
        <div className="container screenshots-window">
            <div className="row">
              <img onClick={this.zoomOutScreenshot} src={this.state.selectedScreenshot} className="img-fluid"></img>
            </div>
        </div>
      </div>
    }

    let screenshotsListHTML;
    if(this.state.screenshotList.length > 0){
      screenshotsListHTML = this.state.screenshotList.map((screenshot, index) =>

      <div onClick={this.zoomScreenshot(index)} className="col-3 container p-4 screenshot-container">
       <h6 className='text-center'>{screenshot.date}</h6>
       <img src={"https://dashboard.realsexdoll.info/screenshots/"+screenshot.imgPath} className="img-thumbnail"></img>
      </div>

      )
    }else{
      screenshotsListHTML = <p>No screenshot found.</p>
    }

    return(
      <div>
        <div className='pop-up' onClick={this.props.close}></div>
        <div className="container pop-up-window screenshots-window">
          <div className='row pt-3'>
            <h2>Screenshots from shift id: {this.props.id}</h2>
          </div>
          <div className='screenshot-wrapper'>
            <div className="row">
                {screenshotsListHTML}
            </div>
          </div>
        </div>
        {windowZoomScreenshot}
      </div>
    )
  }
}

export default PayrollScreenShots;